import { useState } from 'react';

const useNotification = (config = {})=>{
    // Initial State of props to reset
    const initialState = {
        title: '',
        children: '',
        open: false,
        onDismiss: ()=>closeNotification(),
        dismissLabel: '',
        onSubmit: undefined,
        autoDismiss: false,
        submitLabel: '',
        ...config?.defaultProps
    };
    // Create Initial State
    const [props, setProps] = useState(initialState);
    /**
     * Open Notification Hook Action.
     */ const openNotification = (options)=>{
        // Pick notification variant from the list of notification provided to the hook
        const variant = config?.notifications && options?.name && options?.name in config.notifications ? config.notifications[options?.name] : {};
        // Change the state of the notification with the initial state and extended options
        // And open the notification
        setProps({
            ...initialState,
            ...variant,
            ...options?.props,
            open: true
        });
    };
    /**
     * Close Notification Hook Action
     * We extend props to make sure the required props for the notification still exists
     * even though we don't show the notification anymore.
     */ const closeNotification = ()=>setProps((prevState)=>({
                ...prevState,
                open: false
            }));
    /**
     * Return hook data and actions.
     */ return {
        props,
        openNotification
    };
};

export { useNotification };
//# sourceMappingURL=useNotification.es.js.map
